import React from 'react';

const ActionCard: React.FC = () => {
  const handleStartEcg = () => {
    console.log("ECG Monitoring Started");
    // Add logic to start ECG monitoring if applicable
  };

  const handleStopEcg = () => {
    console.log("ECG Monitoring Stopped");
    // Add logic to stop ECG monitoring if applicable
  };

  const handleSnapshot = () => {
    console.log("Snapshot Taken");
    // Add logic for snapshot functionality
  };

  return (
    <div className="card action-card">
      <h3>Actions</h3>
      <button onClick={handleStartEcg} className="action-button">
        Start ECG
      </button>
      <button onClick={handleStopEcg} className="action-button">
        Stop ECG
      </button>
      <button onClick={handleSnapshot} className="action-button">
        Take Snapshot
      </button>
    </div>
  );
};

export default ActionCard;
